import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import { ReferenceInput, required, SelectInput } from "react-admin";

const LeftQuitDismissedStudents = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="instructionLanguageId"
        reference={administrationRequests.getInstructionLanguagesSelect()}
      >
        <SelectInput
          label="Език на обучение"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("instructionLanguageId", e.target.value)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="academicYearId"
        reference={studentRequests.getAcademicYearsSelect()}
      >
        <SelectInput
          label="Учебна година"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("academicYearId", e.target.value)}
        />
      </ReferenceInput>
    </>
  );
};

export default LeftQuitDismissedStudents;
